
import { Injectable } from "@angular/core";
import { HttpService } from "./utils/http.service";
import { IAppointmentStatusEmailModel, IAppointmentStatusChangedModel } from "@models";

@Injectable({ providedIn: 'root' })
export class AppointmentStatusEmailService {
    constructor(private httpService: HttpService) { }

    async getAppointmentStatusEmails(appointmentStatusId: number): Promise<IAppointmentStatusEmailModel[]> {
        return await this.httpService.get("/appointmentStatusEmails/getAppointmentStatusEmails", { appointmentStatusId });
    }

    
    async updateAppointmentStatusEmails(
        appointmentStatusId: number,
        appointmentStatusEmails: IAppointmentStatusEmailModel[],
        deletedIds: number[]
    ): Promise<IAppointmentStatusEmailModel[]> {
        return await this.httpService.post(
            "/appointmentStatusEmails/updateAppointmentStatusEmails",
            {
                appointmentStatusId,
                appointmentStatusEmails,
                deletedIds
            }
        );
    }


    async sendAppointmentStatusesChanged(statusChanges: IAppointmentStatusChangedModel[]): Promise<string> {
        return await this.httpService.post("/appointmentStatusEmails/sendAppointmentStatusesChanged", statusChanges);
    }
}

